<template>
    <div class="morph">
        <div class="logic_wrap">

            <div class="basket_loading" v-if="userStore.othform.is_loading">
                <loading></loading>
            </div>

            <div v-if="userStore.othform.result" class="order_result">
                <div class="grey_border">
                    <div class="title important_blue">Реализация оформлена</div>
                    <div class="case">{{ userStore.othform.message }}</div>
                </div>
            </div>


            <div v-if="userStore.user.web_basket_oth.count === 0" class="basket_empty">
                <div class="grey_border">
                    <div class="title important_blue">Список реализации - пуст</div>
                    <div class="case">Для оформления реализации, наполните список воспользовавшись <span @click="route_to('Search')" class="psevdo_link">Поиском по вашему складу ОТХ</span></div>
                </div>
            </div>

            <div class="basket_wrap" v-if="userStore.user.web_basket_oth.count !== 0 && !userStore.othform.result && !userStore.othform.is_loading">
                <div class="announce grey_border">
                    <div class="case">
                        <p>Для добавления товара на реализацию воспользуйтесь <span @click="route_to('Search')" class="psevdo_link">поиском по Вашему складу ОТХ</span></p>
                        <p>Для реализации товаров необходимо просканировать каждый товар и позицию по отдельности: <a href="/b2b/oth_help" target="_blank">Инструкция по реализации товара со склада ОТХ</a></p>
                    </div>
                </div>
                <div class="sub_title">Товары на сканирование</div>
                <div class="wrapper">
                    <div class="Rtable Rtable--5cols Rtable--collapse">
                        <div class="Rtable-row Rtable-row--head">
                            <div class="Rtable-cell title-cell column-heading">Наименование</div>
                            <div class="Rtable-cell countui-cell column-heading">Кол-во / Просканировано</div>
                            <div class="Rtable-cell summa-cell column-heading">Сканировать</div>
                            <div class="Rtable-cell actions-cell column-heading">Удалить</div>
                        </div>
                        <div class="row Rtable-row" v-for="(item, index) in userStore.user.web_basket_oth.items" :key="index">
                            <div class="Rtable-cell title-cell">
                                <div class="Rtable-cell--heading">Наименование</div>
                                <div class="Rtable-cell--content title-content">{{ item.name }}</div>
                            </div>
                            <div class="Rtable-cell countui-cell">
                                <div class="Rtable-cell--heading">Кол-во / Просканировано</div>
                                <div class="Rtable-cell--content countui-content">
                                    {{ item.count }} / {{ item.scan_count }}
                                </div>
                            </div>
                            <div class="Rtable-cell summa-cell">
                                <div class="Rtable-cell--heading">Сканировать</div>
                                <div class="Rtable-cell--content summa-content">
                                    <span v-if="item.count > item.scan_count" @click="try_scan(item)" class="psevdo_link">Сканировать</span>
                                </div>
                            </div>
                            <div class="Rtable-cell actions-cell">
                                <div class="Rtable-cell--heading">Удалить</div>
                                <div class="Rtable-cell--content actions-content">
                                    <div class="actions_wrap">
                                        <div class="ico del" v-if="!item.lock" @click="try_remove(item)" title="Удалить из реализации">
                                            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                                                <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="b_total">
                    Осталось просканировать: {{ userStore.user.web_basket_oth.scan_items }} товаров {{ userStore.user.web_basket_oth.scan_pos }} позиций
                </div>
                <div class="sub_title">Отсканированые коды</div>
                <div class="wrapper" v-if="userStore.user.web_basket_oth.scan_total_have">
                    <div class="Rtable Rtable--5cols Rtable--collapse">
                        <div class="Rtable-row Rtable-row--head">
                            <div class="Rtable-cell title-cell column-heading">Наименование</div>
                            <div class="Rtable-cell countui-cell column-heading">Порядковый номер</div>
                            <div class="Rtable-cell summa-cell column-heading">Отсканированный код</div>
                            <div class="Rtable-cell actions-cell column-heading">Операции</div>
                        </div>
                        <div class="scans_owner" v-for="(item, index) in userStore.user.web_basket_oth.items" :key="index">
                            <div class="row Rtable-row" v-for="(scan, index_scan) in item.scan" :key="index_scan">
                                <div class="Rtable-cell title-cell">
                                    <div class="Rtable-cell--heading">Наименование</div>
                                    <div class="Rtable-cell--content title-content">{{ item.name }}</div>
                                </div>
                                <div class="Rtable-cell countui-cell">
                                    <div class="Rtable-cell--heading">Порядковый номер</div>
                                    <div class="Rtable-cell--content countui-content">
                                        {{ Number(index_scan)+1 }} / {{ item.count }}
                                    </div>
                                </div>
                                <div class="Rtable-cell summa-cell">
                                    <div class="Rtable-cell--heading">Отсканированный код</div>
                                    <div class="Rtable-cell--content summa-content">
                                        {{ scan }}
                                    </div>
                                </div>
                                <div class="Rtable-cell actions-cell">
                                    <div class="Rtable-cell--heading">Удалить</div>
                                    <div class="Rtable-cell--content actions-content">
                                        <div class="actions_wrap">
                                            <div class="ico del" v-if="!item.lock" @click="try_remove_scan(item,Number(index_scan))" title="Удалить код">
                                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                                                    <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else class="scans_epty">Отсутствуют</div>
                <div class="buttons_wrap">
                    <div class="button_simple b_blue" @click="clear_oth_basket">Очистить список товаров</div>
                    <div class="button_simple b_blue" @click="clear_all_scans">Очистить отсканированые коды</div>
                    <div v-if="userStore.user.web_basket_oth.scan_pos === 0" class="button_simple b_blue" @click="try_sale">Оформить реализацию</div>
                </div>
            </div>
        </div>

        <modal name="modal_scan" :height="700" :width="1200" :adaptive="true">
            <div class="b_close" @click="hideModalScan">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="78.7441" y="13.9842" width="93" height="18" transform="rotate(135 78.7441 13.9842)"/>
                    <rect x="13.3364" y="0.901962" width="93" height="18" transform="rotate(45 13.3364 0.901962)"/>
                </svg>
            </div>
            <div class="all_is_scan scan_title" v-if="userStore.scan.position+1 > userStore.scan.count">
                Все позиции просканированы
            </div>
            <div v-else class="scan_wrap">
                <div class="scan_title">Просканируйте товар</div>
                <div class="announce grey_border">
                    <div class="case">
                        <p>Переведите сканер в режим клавиатуры и переключите раскладку на Английский язык и просканируйте товар. </p>
                        <p>Пожалуйста во время сканирования не нажимайте на клавиши клавиатуры <a href="/b2b/oth_help" target="_blank">Инструкция по реализации товара со склада ОТХ</a></p>
                    </div>
                </div>
                <div class="scan_fields">
                    <div class="row_w_label">
                        <div class="row"><span>{{ userStore.scan.scan_code }}</span></div>
                        <div class="label">Просканированный Код</div>
                    </div>
                    <div class="row_w_label">
                        <div class="row">{{ userStore.scan.title }}</div>
                        <div class="label">Наименование товара</div>
                    </div>
                    <div class="row_w_label">
                        <div class="row">{{ userStore.scan.position+1 }}/{{ userStore.scan.count }}</div>
                        <div class="label">Позиция</div>
                    </div>
                    <div class="scan_result">
                        <div class="scaner_img"></div>
                    </div>
                </div>
            </div>
        </modal>

    </div>


</template>

<script>

import {useUserStore} from "@/stores/UserStore";
import loading from "@/components/support/loading";
import Vue from "vue";
import axios from "axios";

export default {
    name: "BasketOth",
    components: {
        loading,
    },
    setup() {
        const userStore = useUserStore()
        return {
            userStore
        }
    },
    data: function () {
        return {
            page: {
                title: 'Товары на реализацию со склада ОТХ',
                show_menu: false,
            }
        }
    },
    props: ['config'],
    methods: {

        route_to(name) {
            this.$router.push({name: name})
        },


        calc_oth_web_basket() {
            const userStore = useUserStore();


            let scan_items = 0;
            let scan_pos = 0;
            let scan_total_have = 0;
            let count = 0;
            for (const index in userStore.user.web_basket_oth.items) {
                let с_pos = Number(userStore.user.web_basket_oth.items[index].count);
                let scan_item = 1;
                // let item_summa = 0;
                // item_summa = Number(this.user.basket_oth_web.items[index].count) * this.user.basket_oth_web.items[index].price;
                // //this.user.basket_oth_web.items[index].item_summa = item_summa;
                // this.user.basket_oth_web.items[index].sum = item_summa;
                // this.user.basket_oth_web.items[index].lock = false;
                // summa += item_summa;

                if (typeof (userStore.user.web_basket_oth.items[index].scan) === 'object' && Object.keys(userStore.user.web_basket_oth.items[index].scan).length > 0) {
                    userStore.user.web_basket_oth.items[index].scan_count = Object.keys(userStore.user.web_basket_oth.items[index].scan).length
                    с_pos = с_pos - userStore.user.web_basket_oth.items[index].scan_count;
                    if (с_pos === 0) {
                        scan_item = 0;
                    }
                } else {
                    userStore.user.web_basket_oth.items[index].scan_count = 0;
                }
                scan_total_have = scan_total_have + userStore.user.web_basket_oth.items[index].scan_count;
                scan_pos = scan_pos + с_pos;
                scan_items = scan_items + scan_item;
                count += 1;
            }
            //this.user.basket_oth_web.summa = summa;
            userStore.user.web_basket_oth.count = count;
            userStore.user.web_basket_oth.scan_pos = scan_pos;
            userStore.user.web_basket_oth.scan_items = scan_items;
            userStore.user.web_basket_oth.scan_total_have = scan_total_have;

            if (count > 0) {
                userStore.user.web_basket_oth.empty = false;
            } else {
                userStore.user.web_basket_oth.empty = true;
            }
        },

        try_remove(del_item) {

            const userStore = useUserStore();
            const params = new URLSearchParams();
            params.append('id', del_item.id + '_' + del_item.storehouse);

            this.$http
                .post('/api/basket_oth_remove', params)
                .then((response) => {
                    var data = response.data;

                    let del_object = userStore.user.web_basket_oth.items.findIndex(item => item.id === del_item.id && item.storehouse === del_item.storehouse)
                    userStore.user.web_basket_oth.items.splice(del_object, 1)

                    this.calc_oth_web_basket();

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        Vue.prototype.$notifySuccess(data.message);

                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        Vue.prototype.$notifyError(data.message);
                    }


                })
                .catch((error) => {
                    console.log(error);
                });


        },

        try_remove_scan(item, position) {

            const userStore = useUserStore();
            const params = new URLSearchParams();
            params.append('id', item.id + '_' + item.storehouse);
            params.append('position', position);

            this.$http
                .post('/api/basket_oth_remove_scan', params)
                .then((response) => {
                    let data = response.data;

                    let obj = userStore.user.web_basket_oth.items.find(i => i.id === item.id && i.storehouse === item.storehouse);
                    delete obj.scan[position];

                    //obj.scan.splice(position, 1)

                    this.calc_oth_web_basket();

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);
                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }


                })
                .catch((error) => {
                    console.log(error);
                });

        },

        try_scan(item) {

            this.userStore.scan.title = item.name;
            this.userStore.scan.id = item.id;
            this.userStore.scan.count = item.count;
            this.userStore.scan.storehouse = item.storehouse;


            let real_pos  = Number(item.scan_count);

            for (let i = 0; i < Number(item.scan_count); i++) {
                if (typeof item.scan[i] === 'undefined') {
                    real_pos = i;
                }

            }



            this.userStore.scan.position = real_pos;


            this.userStore.scan.scan_code = 'Ожидание сканирования';
            //this.userStore.scan.scan_code = '-';
            this.$modal.show('modal_scan');
            window.addEventListener('keypress', this.keyDownHandler);
        },

        keyDownHandler(e) {
            //console.log(e.key)
            //console.log(e)
            let scan_code = this.userStore.scan.scan_code
            let is_enter = false;
            //let position = 1;

            // Количество при котором код будет считаться верным
            let count_complite = 84;

            if (scan_code === 'Ожидание сканирования') {
                scan_code = '';
            }

            if (e.keyCode === 13) {
                //e.key = "\n";
                is_enter = true;
            }
            if (e.keyCode === 29) {
                return
            }
            if (e.keyCode === 232) {
                return
            }
            // if (e.keyCode > 127) {
            //   return
            // }

            if (e.key === 'Enter') {
                //e.key = "\n";
                is_enter = true;
            }
            if (e.key === 'Alt') {
                return
            }
            if (e.key === 'Shift') {
                return
            }
            if (e.key === 'Control') {
                return
            }
            if (e.key === 'Escape') {
                return
            }
            if (e.key === ']') {
                return
            }

            if (is_enter) {
                //console.log('KEY SAVE: ',"\n")
                scan_code = scan_code + "\n"
            } else {
                //console.log('KEY SAVE: ',e.key)
                scan_code = scan_code + e.key
            }

            this.userStore.scan.scan_code = scan_code

            if (is_enter) {

                window.removeEventListener('keypress', this.keyDownHandler);

                var test = scan_code.length
                if (count_complite !== test) {
                    this.$notifyError('Ошибка сканирования (проверьте раскладку должна быть En)')
                    this.userStore.scan.scan_code = ''
                    window.addEventListener('keypress', this.keyDownHandler);
                    return
                }
                this.$notifyInfo('Отправка данных')


                this.send_oth_scan();

            }
        },


        try_sale() {

            this.$notifyInfo('Отправляем запрос реализацию');

            this.userStore.othform.is_loading = true;

            this.$http.post('/api/basket_oth_sale', {})
                .then((response) => {
                    let data = response.data;

                    this.userStore.othform.is_loading = false;

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);
                        this.clear_oth_basket();

                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }


                })
                .catch((error) => {
                    console.log(error);
                });


        },


        send_oth_scan() {

            const params = new URLSearchParams();

            params.append('id', this.userStore.scan.id);
            params.append('storehouse', this.userStore.scan.storehouse);
            params.append('position', this.userStore.scan.position);
            params.append('scan', this.userStore.scan.scan_code);

            this.$http
                .post('/api/basket_oth_scan', params)
                .then((response) => {

                    let data = response.data;


                    let obj = this.userStore.user.web_basket_oth.items.find(i => i.id === this.userStore.scan.id && i.storehouse === this.userStore.scan.storehouse);



                    if (typeof obj.scan === 'undefined') {
                        obj.scan = [];
                        //obj.scan[0] = undefined;
                    }

                    console.log(obj.scan[0])


                    obj.scan[this.userStore.scan.position] = this.userStore.scan.scan_code;


                    this.userStore.scan.position = this.userStore.scan.position + 1
                    this.userStore.scan.result = data.message;
                    this.userStore.scan.scan_code = 'Ожидание сканирования';

                    this.calc_oth_web_basket();
                    window.addEventListener('keypress', this.keyDownHandler);

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);
                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }

                })
                .catch((error) => {
                    console.log(error);
                });


        },


        hideModalScan() {
            this.$modal.hide('modal_scan');
            window.removeEventListener('keypress', this.keyDownHandler);
        },

        clear_all_scans() {
            this.$notifyInfo('Очищаем все просканированные');

            this.userStore.othform.is_loading = true;
            this.$http.post('/api/basket_oth_clear_scan', {})
                .then((response) => {
                    let data = response.data;


                    this.userStore.othform.is_loading = false;
                    this.calc_oth_web_basket();

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);
                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }

                })
                .catch((error) => {
                    console.log(error);
                });

        },

        clear_oth_basket() {
            this.$notifyInfo('Очищаем корзину');


            this.userStore.othform.is_loading = true;
            this.$http.post('/api/basket_oth_clear', {})
                .then((response) => {
                    let data = response.data;


                    this.userStore.othform.is_loading = false;
                    this.calc_oth_web_basket();

                    if (typeof (data.success) !== "undefined" && (data.success === true)) {
                        this.$notifySuccess(data.message);
                    }
                    if (typeof (data.error) !== "undefined" && (data.error === true)) {
                        this.$notifyError(data.message);
                    }

                })
                .catch((error) => {
                    console.log(error);
                });
        },

        try_order() {
            this.$notifyInfo('Отправляем данные заказа');
            this.userStore.try_order().then(this.response_process);
        },


    },

    created() {
        this.userStore.order.success = false;
        this.$emit('setPagesVars', this.page);
    },

    mounted() {
        this.calc_oth_web_basket();
    }

}
</script>

<style scoped>
.scans_epty {
    padding: 20px 0 10px 5px;
}

.sub_title {
    padding: 20px 0 10px 5px;
    font-size: 24px;
    font-weight: 600;
    color: #174A8B;
}

.buttons_wrap {
    display: flex;
    flex-direction: row;
    margin: 30px 0 50px 0;
}

.buttons_wrap .button_simple {
    margin: 0 10px 0 10px;
}

.basket_empty {
    margin: 50px 0 50px 0;
}

.order_wrap {
    margin: 50px 0 50px 0;
}

.input_wrap, .text_wrap, .s_wrap, .send_wrap {
    width: 100%;
}

.input_gray, .textarea_gray {
    width: 100%;
}

.s_wrap, .input_wrap, .text_wrap, .send_wrap {
    margin-bottom: 20px;
    margin-right: 0px;
}

.order_result {
    margin: 50px 0 50px 0;
}

.order_result .grey_border {
    margin: 25px 0 0 0;
}

.count_ui .row {
    border-bottom: 1px dashed #dee2e6;
    margin: 5px 0 5px 0;
    padding: 5px 0 5px 0;
}

.add_ui {
    width: 133px;
    height: 38px;
    border: solid 1px #ADADAD;
    display: flex;
    flex-direction: row;
}

.add_ui .added {
    font-size: 24px;
    font-weight: bold;
    color: #174A8B;
    width: 40px;
    line-height: 28px;
    color: #659157;
    margin: 4px 0 0 0;
    text-align: center;
}

.add_ui .button {
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 18px;
    font-weight: bold;
    color: #ADADAD;
    text-align: center;
    border: solid 1px #FFF;
    cursor: pointer;
    margin: 5px 2px 0px 2px;
}

.add_ui .active, .add_ui .button:hover {
    border: solid 1px #ADADAD;
    color: #174A8B;
}

/* RTABLE start
==================================== */
* {
    box-sizing: border-box;
}

.wrapper {
    width: 100%;
    margin-bottom: 30px;
}


/* Table column sizing
================================== */
.scans_owner {
    width: 100%
}

.title-cell {
    width: 43%;
    padding-left: 2%;
}

.price-cell {
    width: 50px
}

.countui-cell {
    width: 150px;
}

.summa-cell {
    width: 100px;
}

.actions-cell {
    width: 100px;
    text-align: center
}

/* Apply styles
================================== */
.Rtable {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
}

.Rtable .Rtable-row {
    width: 100%;
    display: flex;
    border-bottom: 1px dashed #b7b7b7;
}

.Rtable .checked {
    background-color: #40769E;
}

.Rtable .Rtable-row .Rtable-cell {
    box-sizing: border-box;
    flex-grow: 1;
    overflow: hidden;
    list-style: none;
    line-height: 38px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.Rtable .Rtable-row .Rtable-cell.column-heading {
    background-color: #174A8B;
    color: white;
}

.Rtable .Rtable-row .Rtable-cell .Rtable-cell--heading {
    display: none;
}

.Rtable a {
    color: #174A8B;
    text-decoration: underline;
}

.Rtable a:hover {
    color: #174A8B;
    text-decoration: underline;
}

.Rtable .actions_wrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.Rtable .actions_wrap .ico {
    display: block;
    width: 25px;
    height: 25px;
    margin-right: 20px;
    margin-top: 5px;
    cursor: pointer;
}

.Rtable .actions_wrap .ico svg {
    width: 25px;
    height: 25px;
    fill: #174A8B;
}

/* Responsive
==================================== */
@media all and (max-width: 1200px) {
    .Rtable--collapse {
        display: block;
        width: 100%;
        box-shadow: none;
    }

    .Rtable--collapse .Rtable-row {
        box-sizing: border-box;
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin: 20px 0 20px 0;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell {
        width: 100% !important;
        display: flex;
        align-items: center;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell .Rtable-cell--heading {
        display: inline-block;
        flex: 1;
        max-width: 120px;
        min-width: 120px;
        color: #174A8B;
    }

    .Rtable--collapse .Rtable-row .Rtable-cell .Rtable-cell--content {
        flex: 2;
    }

    .Rtable--collapse .title-cell {
        order: -1;
        padding-left: 0 !important;
    }

    .Rtable--collapse .title-cell .Rtable-cell--content {
        padding-left: 0 !important;
    }

    .Rtable--collapse .Rtable-row--head {
        display: none;
    }

    .Rtable--collapse .actions-cell {
        text-align: left;
    }

    .Rtable--collapse .actions-cell .actions_wrap {
        justify-content: left;
    }
}

.no-flexbox .Rtable {
    display: block;
}

.no-flexbox .Rtable.Rtable-cell {
    width: 100%;
}

/* RTABLE END
==================================== */
</style>
